import instanciaAxios from './InterceptorAxios';

const servicioComprobante = {
  guardarConcepto(objeto) {
    return instanciaAxios.post('/comprobante/optenerComprobante.json', objeto)
  },
  buscarUuid(comprobante) {
    return instanciaAxios.post('/comprobante/buscarFoliosFiscales.json', comprobante);
  },
  obtenerClaveProServ(objeto) {
    return instanciaAxios.post('/catalogoSAT/claveProServ.json', objeto)
  },
  ontenerClaveUnidad(objeto) {
    return instanciaAxios.post('catalogoSAT/claveClaveUnidad.json', objeto);
  },
  procesarcomprobante(objeto) {
    return instanciaAxios.post('/comprobante/procesarcomprobante.json', objeto)
  },
  validarFechaCreacion(objeto) {
    return instanciaAxios.post('/comprobante/validarFecha.json',objeto)
  },

  consultarFacturaNru(objeto) {
    return instanciaAxios.post('/comprobante/paginacion.json',objeto)
  }
}

export default servicioComprobante;